import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export function translatedTitle(key: string): ResolveFn<string> {
  return () => inject(TranslateService).instant(key) as string;
}
